import * as actions from './eStoreOrder/actions'
import * as mutations from './eStoreOrder/mutations'
import * as getters from './eStoreOrder/getters'

import { dataProps } from './eStoreOrder/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.confirmation_date',
        sort_direction: 1, 
        search_term: '', 
        search_term_array: [],
        total_amount: 0    
    },
    props: null
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreOrder.js